import { LitElement, html, css } from 'lit-element';

export class UcHeaderLogo extends LitElement {
  static get properties() {
    return {
      url: { type: String },
      img: { type: String },
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }
      a,
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    `;
  }

  constructor() {
    super();
    this.url = '';
    this.img = '';
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    const a = this.querySelector('a');
    const img = this.querySelector('img');

    if (a) {
      this.url = a.getAttribute('href');
    }
    if (img) {
      this.img = img.getAttribute('src');
    }
  }

  render() {
    return html`
      <a href="${this.url}">
        <img src="${this.img}" alt="" />
      </a>
    `;
  }
}
